/* unplugin-vue-components disabled */import { render } from "./templateDemeTextAreaEdit.vue?vue&type=template&id=0041a22c&scoped=true"
import script from "./templateDemeTextAreaEdit.vue?vue&type=script&lang=js"
export * from "./templateDemeTextAreaEdit.vue?vue&type=script&lang=js"

import "./templateDemeTextAreaEdit.vue?vue&type=style&index=0&id=0041a22c&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0041a22c"]])

export default __exports__